(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["behandelingen-lijst"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  let tabs = document.querySelectorAll('.behandelingen-sidebar .categorie-block');
  
  // Function om URL parameters te lezen
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
  
  // Function om tab te activeren
  function activateTab(targetTabTitle) {
    // Deactiveer alle tabs en panels
    tabs.forEach(function(tab) {
      tab.classList.remove('is-active');
    });
    
    document.querySelectorAll('.behandeling-block').forEach(function(panel) {
      panel.classList.remove('is-active');
      panel.style.display = 'none';
    });
    
    // Activeer de target tab
    const targetTab = document.querySelector('.categorie-block[tab-title="' + targetTabTitle + '"]');
    const targetPanel = document.querySelector('.behandeling-block.' + targetTabTitle);
    
    if (targetTab && targetPanel) {
      targetTab.classList.add('is-active');
      targetPanel.classList.add('is-active');
      targetPanel.style.display = 'block';
      console.log('Activated tab:', targetTabTitle);
      return true;
    }
    
    return false;
  }
  
  // Check URL parameter voor category
  const categoryFromUrl = getUrlParameter('category');
  let tabActivated = false;
  
  if (categoryFromUrl) {
    console.log('Found category in URL:', categoryFromUrl);
    
    // Probeer verschillende varianten van de category handle
    const possibleHandles = [
      categoryFromUrl,
      categoryFromUrl.toLowerCase(),
      categoryFromUrl.replace(/-/g, ' ').toLowerCase(),
      categoryFromUrl.replace(/\s+/g, '-').toLowerCase()
    ];
    
    for (let handle of possibleHandles) {
      if (activateTab(handle)) {
        tabActivated = true;
        break;
      }
    }
    
    // Als geen exacte match, probeer partial match
    if (!tabActivated) {
      tabs.forEach(function(tab) {
        const tabTitle = tab.getAttribute('tab-title');
        if (tabTitle && tabTitle.toLowerCase().includes(categoryFromUrl.toLowerCase())) {
          activateTab(tabTitle);
          tabActivated = true;
          return;
        }
      });
    }
  }
  
  // Als geen URL parameter of geen match gevonden, activeer eerste tab
  if (!tabActivated && tabs.length > 0) {
    const firstTab = tabs[0];
    const firstTabTitle = firstTab.getAttribute('tab-title');
    activateTab(firstTabTitle);
    console.log('Activated first tab as fallback:', firstTabTitle);
  }
  
  // Event listeners voor tab clicks
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const currentTabTitle = this.getAttribute('tab-title');
      activateTab(currentTabTitle);
      
      // Update URL parameter (optioneel)
      const url = new URL(window.location);
      url.searchParams.set('category', currentTabTitle);
      window.history.replaceState(null, '', url);
    });
  });
  
  console.log('Behandelingen lijst initialized');
  console.log('Found tabs:', tabs.length);
  console.log('Category from URL:', categoryFromUrl);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
